import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = "/database"; // already under /api/admin via axiosInstance

const BackupService = {
  /**
   * Trigger manual database backup
   */
  async createBackup() {
    const { data } = await axiosInstance.post(`${BASE_URL}/backup`);
    return data;
  },

  /**
   * List all available backup files
   */
  async listBackups() {
    const { data } = await axiosInstance.get(`${BASE_URL}/backups`);
    return data;
  },

  /**
   * Download specific backup file
   */
  async downloadBackup(filename) {
    const response = await axiosInstance.get(
      `${BASE_URL}/backup/${filename}/download`,
      {
        responseType: "blob",
      }
    );
    
    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Restore database from uploaded backup file
   */
  async restoreBackup(file) {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axiosInstance.post(`${BASE_URL}/restore`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },

  /**
   * Delete specific backup file
   */
  async deleteBackup(filename) {
    const { data } = await axiosInstance.delete(`${BASE_URL}/backup/${filename}`);
    return data;
  },

  /**
   * Get backup log file content
   */
  async getBackupLogs(lines = 100) {
    const { data } = await axiosInstance.get(`${BASE_URL}/logs`, {
      params: { lines },
    });
    return data;
  },

  /**
   * Get backup statistics
   */
  async getBackupStatistics() {
    const { data } = await axiosInstance.get(`${BASE_URL}/statistics`);
    return data;
  },
};

export default BackupService;
